// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import { getPayFrequncey, dateRange, getCurrencySign, getDaysAmount } from 'public/utils.js';
import { addRepeaterItem, repeaterInputItemChange, currentDeductionsSum, currentAdditionsSum } from 'public/additionsDeductionsRepeater.js';
import { downloadPDF } from 'backend/generatePdf.jsw';
import { openLightbox } from 'wix-window';
import { uuid } from 'uuidv4';
import wixLocation from 'wix-location';
import { sendBiEvent } from 'public/biSender';
import wixWindow from 'wix-window';

//json obj that will be sent to the backend
let jsonPaystub = {
    paycheckNo: "",
    logo: "",
    employeeName: "",
    employeeState: "",
    employeeAddress: "",
    employeeCountry: "",
    employeeId: "",
    employeeEmail: "",
    businessName: "",
    businessEmail: "",
    businessCountry: "",
    businessAddress: "",
    businessState: "",
    payDate: "",
    payPeriodStart: "",
    payPeriodEnd: "",
    currency: "",
    employmentType: "Employee",
    dateHired: "",
    salaryType: "Salary",
    payFrequency: "",
    hoursWorked: "",
    currentEarnings: "",
    additions: [],
    deductions: [],
    ydtGross: "",
    ydtDeductions: "",
    ydtNetPay: "",
    netPay: "",

}
const BUTTON = 'button';
const TEXT_INPUT = 'textInput';
const DATE_INPUT = 'dateInput';
const DROPDOWN = 'dropDown';

const inputFields = [
    { id: "0", name: "businessName", type: TEXT_INPUT },
    { id: "1", name: "businessAddress", type: TEXT_INPUT },
    { id: "2", name: "employeeName", type: TEXT_INPUT },
    { id: "3", name: "employeeAddress", type: TEXT_INPUT },
    { id: "4", name: "employeeId", type: TEXT_INPUT },
    { id: "5", name: "businessEmail", type: TEXT_INPUT },
    { id: "6", name: "employeeEmail", type: TEXT_INPUT },
    { id: "7", name: "paycheckNo", type: TEXT_INPUT },
    { id: "8", name: "hourlyRate", type: TEXT_INPUT },
    { id: "9", name: "annualSalary", type: TEXT_INPUT },
    { id: "10", name: "hoursWorked", type: TEXT_INPUT },
    { id: "11", name: "businessCountry", type: DROPDOWN },
    { id: "12", name: "businessState", type: DROPDOWN },
    { id: "13", name: "employeeCountry", type: DROPDOWN },
    { id: "14", name: "employeeState", type: DROPDOWN },
    { id: "15", name: "currency", type: DROPDOWN },
    { id: "16", name: "payFrequency", type: DROPDOWN },
    { id: "17", name: "payDate", type: DATE_INPUT },
    { id: "18", name: "payPeriodStart", type: DATE_INPUT },
    { id: "19", name: "payPeriodEnd", type: DATE_INPUT },
    { id: "20", name: "dateHired", type: DATE_INPUT }
];
//arrays that will fill the repeaters data
let additionsArray;
let deductionsArray;

//list of field names for the preview section
const previewPaystubFields = [
    "paycheckNoP",
    "employeeNameP",
    "logoP",
    "employeeEmailP",
    "employeeAddressP",
    "employeeCountryP",
    "employeeStateP",
    "businessNameP",
    "businessEmailP",
    "businessAddressP",
    "businessCountryP",
    "businessStateP",
    "PemployeeName",
    "PemployeeId",
    "PpayDate",
    "PpaycheckNo",
    "PpayPeriodStart",
    "PpayPeriodEnd",
    "PsalaryType",
    "PdateHired",
    "PemploymentType",
    "PpayFrequency",
    "PhoursWorked",
    "Pcurrency"
]

const biList = {
    'button18': { type: BUTTON, biName: 'create_your_store', link: 'https://www.wix.com/new/intro' },
    'button5': { type: BUTTON, biName: ' get_started_first  ', link: '/home#anchor1' },
    'button4': { type: BUTTON, biName: 'find_out_more', link: '/home#anchor2' },
    'button3': { type: BUTTON, biName: 'view_sample_paystub  ', link: 'https://c4cf9e3e-da09-4446-8748-6c05969a4c53.usrfiles.com/ugd/c4cf9e_24761d3de5f049b2a468cc3aa49498bb.pdf' },
    'businessName': { type: TEXT_INPUT, biName: 'start_paystub_form' },
    // 'employeeName': { type: TEXT_INPUT, biName: 'start_employee_form' },
    'paycheckNo': { type: TEXT_INPUT, biName: 'start_salary_details_form' },
    'downLoadInvoiceButton': { type: BUTTON, biName: 'download_paystub  ', onClickFunc: downloadPdfFromServer },
    'emailYourClientButton': { type: BUTTON, biName: 'email_paystub', onClickFunc: emailPdfFromServer },
    'button11': { type: BUTTON, biName: 'create_paystub_2', link: '/home#anchor1' },
    'button9': { type: BUTTON, biName: 'create_paystub_3', link: '/home#anchor1' },
    'button1': { type: BUTTON, biName: 'create_your_store_last', link: 'https://www.wix.com/new/intro' },

}

const mobileBiList = {
    'button5': { type: BUTTON, biName: ' get_started_first  ', link: '/home#anchor1' },
    'button4': { type: BUTTON, biName: 'find_out_more', link: '/home#anchor2' },
    'button3': { type: BUTTON, biName: 'view_sample_paystub  ', link: 'https://c4cf9e3e-da09-4446-8748-6c05969a4c53.usrfiles.com/ugd/c4cf9e_24761d3de5f049b2a468cc3aa49498bb.pdf' },
    'businessName': { type: TEXT_INPUT, biName: 'start_paystub_form' },
    'paycheckNo': { type: TEXT_INPUT, biName: 'start_salary_details_form' },
    'downLoadInvoiceButton': { type: BUTTON, biName: 'download_paystub  ', onClickFunc: downloadPdfFromServer },
    'emailYourClientButton': { type: BUTTON, biName: 'email_paystub', onClickFunc: emailPdfFromServer },
    'button11': { type: BUTTON, biName: 'create_paystub_2', link: '/home#anchor1' },
    'button9': { type: BUTTON, biName: 'create_paystub_3', link: '/home#anchor1' },
    'button1': { type: BUTTON, biName: 'create_your_store_last', link: 'https://www.wix.com/new/intro' },

}

let imgUrl;

let payFrequncey;
// let monthsFromDayOne = 1;
let currentEarnings = 0,
    ydtGross = 0,
    ydtDeduction = 0,
    ydtIncome = 0,
    netPay = 0;
let hourly, currentYear;

let hoursWorked;
let annualSalary;

function getElement(elementId) {
    return $w(`#${elementId}`);
}

function isMobile() {
    let ismobile = false;
    if (wixWindow.formFactor === "Mobile") {
        ismobile = true;
    }
    return ismobile;
}

$w.onReady(function () {

    initBiEvent();
    init()
});

function init() {
    additionsArray = [{ _id: uuid(), type: "", amount: "" }];
    deductionsArray = [{ _id: uuid(), type: "", amount: "" }];
    $w('#salaryType').onChange(e => employeeStatusChanged(e));
    $w('#employmentType').onChange(e => employemntTypeChange(e))
    $w('#wasHiredThisYear').onChange(e => enableCheckbox(e));
    $w('#uploadButton').onChange(e => uploadButton_change(e));
    const mobile = isMobile();
    const repeaterNamesList = [
        "additions",
        "deductions"
    ];

    let { length: allRepeaterLength } = repeaterNamesList;

    //looping on the 2 repeaters and setting item input change event
    for (let i = 0; i < allRepeaterLength; i++) {
        let arr, callbackFunction;

        if (repeaterNamesList[i] === "additions") {
            arr = additionsArray
            callbackFunction = calculateNetpay

        } else {
            arr = deductionsArray
            callbackFunction = calculateYdtDeduction

        }
        repeaterInputItemChange($w, repeaterNamesList[i], arr, jsonPaystub, callbackFunction, mobile);
    }
    //making a custom validtaion for the input fields
    // setValidationForSpecialChar();
    // setValidationForEmail();
    addRepeateritem();
    initTitlesOnChange();
}

function initBiEvent() {
    // let list = biList;

    // if (isMobile()) {
    //     list = mobileBiList
    // }
    const list = isMobile() ? mobileBiList : biList
    for (let componentName in list) {
        if (biList[componentName].type === BUTTON) {
            $w(`#${componentName}`).onClick((event) => {
                sendBiEvent(biList[componentName].biName);
                if (biList[componentName].link) {
                    wixLocation.to(biList[componentName].link);
                }

                if (biList[componentName].onClickFunc)
                    biList[componentName].onClickFunc();
            });
        } else if (biList[componentName].type === TEXT_INPUT) {
            $w(`#${componentName}`).onFocus((event) => {
                sendBiEvent(biList[componentName].biName);
            });
        }
    }
}

function addRepeateritem() {

    const mobiel = isMobile();
    $w('#additions').data = additionsArray;

    if (!isMobile()) {
        $w('#Pdeductions').data = deductionsArray;
        $w('#Padditions').data = additionsArray;
    }

    $w('#addAdditions').onClick(() => {
        addRepeaterItem($w, "additions", additionsArray, 'additionsType', 'additionsAmount', mobiel);

    });

    $w('#deductions').data = deductionsArray;

    $w('#addDeductions').onClick(() => {
        addRepeaterItem($w, 'deductions', deductionsArray, 'deductionsType', 'deductionsAmount', mobiel)

    });

}

function initTitlesOnChange(inputsArr, inputs) {
    for (let i = 0; i < inputFields.length; i++) {
        const fieldName = inputFields[i].name
        const fieldType = inputFields[i].type;
        const element = getElement(fieldName);

        if (fieldType === DROPDOWN) {
            element.onChange(e => {
                defineDropdownFieldTitleLogic(e, fieldName);
                fillPreviewPaystub(e)
            })
        } else if (fieldType === TEXT_INPUT) {
            element.onInput(e => {
                defineInputFieldTitleLogic(e, fieldName);
                fillPreviewPaystub(e)

            })

        } else {
            element.onChange(e => {
                defineDatePickerFieldTitleLogic(e, fieldName);
                fillPreviewPaystub(e)
            })
        }
    }

}

function fillPreviewPaystub(e) {
    let { id, value } = e.target;
    // console.log("input id and value", id, value);

    if (id === "payFrequency" || id === "hourlyRate" || id === "annualSalary" || id === "hoursWorked") {
        calculateCurrentEarnings();
    }

    if (id === "payPeriodEnd" || id === "payPeriodStart" || id === "payDate" || id === "dateHired") {
        calculateCurrentEarnings();
    }

    if (!isMobile()) {
        if ($w('#PemploymentType').hidden) {
            $w('#PemploymentType').show();
        }
        if ($w('#PsalaryType').hidden) {
            $w('#PsalaryType').show();
        }

        for (let i = 0; i < previewPaystubFields.length; i++) {
            if ($w(`#P${id}`).id === previewPaystubFields[i]) {
                if (value instanceof Date) {
                    setPrevieDate(id, value)

                } else {

                    jsonPaystub[id] = value;

                    if (id === "currency") {
                        let sign = getCurrencySign(value);

                        $w(`#P${id}`).text = sign;
                        $w(`#P${id}`).show();
                    } else {
                        $w(`#P${id}`).text = value;
                        $w(`#P${id}`).show();
                    }

                }
            }
            //adding periview fields to json 
            if ($w(`#${id}P`).id === previewPaystubFields[i]) {
                jsonPaystub[id] = value;
                $w(`#${id}P`).text = value;
                $w(`#${id}P`).show();

            }
        }
    } else {
        if (value instanceof Date) {
            setPrevieDate(id, value)

        } else {

            jsonPaystub[id] = value;

        }
    }

}

function setPrevieDate(id, value) {
    const options = {
        day: "numeric",
        month: "numeric",
        year: "numeric"
    };
    if (!isMobile()) {
        $w(`#P${id}`).text = value.toLocaleDateString("en-US", options);
    }
    // if (id === "payPeriodStart") {
    //     if (!isMobile()) {
    //         $w(`#P${id}`).text = value.toLocaleDateString("en-US", options) + " " + "-"
    //     }
    // } else if (!isMobile()) {
    //     $w(`#P${id}`).text = value.toLocaleDateString("en-US", options);
    // }

    jsonPaystub[id] = value.toLocaleDateString("en-US", options);
    if (!isMobile()) {
        $w(`#P${id}`).show();
        $w('#dateComma').show();
    }
}

async function getPictureUrl() {
    const uploadedFile = await $w('#uploadButton').startUpload();
    imgUrl = 'https://static.wixstatic.com/media/';
    imgUrl += uploadedFile.url.split('/')[3];
}

export async function uploadButton_change(e) {

    let { value } = e.target;
    let files = value;
    if (files.length > 0) {

        $w('#loaderGif').show();
        await getPictureUrl();
        $w('#logo').src = imgUrl;
        $w('#logo').fitMode = "fit"
        jsonPaystub['logo'] = imgUrl;
        $w('#loaderGif').hide();
        if (!isMobile()) {
            $w('#customImage').setAttribute('change-image', imgUrl);
        }

        sendBiEvent('upload_logo');
    } else {

        $w('#logo').src = 'https://static.wixstatic.com/media/4e13b1_a5c13bc3323e4fb996fc830592358302~mv2.jpg/v1/fill/w_180,h_180,al_c,lg_1,q_80/logo.webp';

        if (!isMobile()) {
            $w('#customImage').setAttribute('change-image', 'https://static.wixstatic.com/media/b71c4b_c8f1849ce4ec4afc8d39722b14992f8a~mv2.png');
        }

        jsonPaystub['logo'] = "";
        $w('#loaderGif').hide();
    }
}

function employemntTypeChange(e) {
    fillPreviewPaystub(e)
}

function employeeStatusChanged(e) {
    let { value } = e.target;
    // console.log(value);
    if (value === "Hourly") {
        $w('#annualSalaryGroup').collapse();
        $w('#PsalaryType').text = 'Hourly';
        $w('#annualSalary').value = null;
        $w('#annualSalary').required = false;
        // $w('#annualSalary').validity.valid = true;
        $w('#hoursWorkedTitle').hide();
        $w('#hourlyRateTitle').hide();
        $w('#hoursWorked').enable();
        $w('#hourlyRate').enable();
        $w('#hoursWorked').required = true;
        $w('#hourlyRate').required = true;
        $w('#hoursWorkedGroup').expand();
        $w('#hourlyRateGroup').expand();
    } else {
        $w('#annualSalaryGroup').expand();
        $w('#annualSalary').required = true;
        $w('#annualSalaryTitle').show();
        $w('#hoursWorked').disable();
        $w('#PsalaryType').text = 'Salary';
        $w('#hourlyRate').disable();
        $w('#hoursWorked').value = null;
        $w('#hourlyRate').value = null;
        $w('#hoursWorked').required = false;
        $w('#hourlyRate').required = false;
        $w('#hoursWorkedGroup').collapse();
        $w('#hourlyRateGroup').collapse();
        $w('#PhoursWorked').hide();
        jsonPaystub['hoursWorked'] = '';
    }

}

/////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
//////////////////////title show up on change///////////////////////
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
function defineInputFieldTitleLogic(e, fieldName) {
    let { length: size } = e.target.value

    if (size > 0)
        $w(`#${fieldName}Title`).show()
    else
        $w(`#${fieldName}Title`).hide();
}

function defineDropdownFieldTitleLogic(e, fieldName) {
    let { length: size } = e.target.value
    if (size > 0) {
        $w(`#${fieldName}Title`).show();
        checkIfUsa(e, $w(`#${fieldName}`));
    } else
        $w(`#${fieldName}Title`).hide();
}

function defineDatePickerFieldTitleLogic(e, fieldName) {
    let { value } = e.target;
    if (value !== "") {
        $w(`#${fieldName}Title`).show();
        dateValidation(e);
    } else
        $w(`#${fieldName}Title`).hide();
}
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////// 
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///checking if the country is usa and then show the state dropbox ///
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
function checkIfUsa(e, dropdown) {
    const businessCountry = "businessCountry";
    const employeeCountry = "employeeCountry";
    const { id } = dropdown;

    if (id === businessCountry || id === employeeCountry) {
        if (e.target.value === "United States") {
            if (id === businessCountry) {
                $w('#businessState').enable();
                $w('#businessState').required = true;
                // $w('#businessStateP').expand();
            } else {
                $w('#employeeState').enable();
                $w('#employeeState').required = true;
                // $w('#employeeStateP').expand();
            }

        } else {

            if (id === businessCountry) {
                $w('#businessState').value = "";
                $w('#businessStateTitle').hide();
                $w('#businessState').disable();
                $w('#businessState').required = false;
                // $w('#businessStateP').collapse();
            } else {
                $w('#employeeState').value = "";
                $w('#employeeStateTitle').hide();
                $w('#employeeState').disable();
                $w('#employeeState').required = false;
                // $w('#employeeStateP').collapse();
            }

        }
    }

}
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////// 
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
////////////////////validate the paycheck dates////////////////////// 
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
function dateValidation(e) {
    let { id: currentDatePicker } = e.target;

    let start = new Date($w('#payPeriodStart').value)
    let end = new Date($w('#payPeriodEnd').value)
    let payDate = new Date($w('#payDate').value)
    let dateHired = new Date($w('#dateHired').value);

    switch (currentDatePicker) {
    case "payDate":
        let defultMonth = new Date(payDate);
        defultMonth.setMonth(defultMonth.getMonth() - 1);

        let issueStartGap = new Date(payDate);
        issueStartGap.setDate(issueStartGap.getDate() - 1)

        $w('#payPeriodStart').maxDate = issueStartGap;
        $w('#payPeriodEnd').maxDate = issueStartGap;

        break;

    case "payPeriodStart":

        let periodStartendGap = new Date(start);
        periodStartendGap.setDate(periodStartendGap.getDate())
        $w('#dateHired').value = null;
        $w('#payPeriodEnd').minDate = periodStartendGap;
        $w('#dateHired').maxDate = periodStartendGap;
        periodStartendGap.setDate(periodStartendGap.getDate() + 1);
        if (end > start) {
            let periodIssueGap = new Date(end);
            periodIssueGap.setDate(periodIssueGap.getDate() + 1);
            $w('#payDate').minDate = periodIssueGap;
        } else {
            $w('#payDate').minDate = periodStartendGap;
        }

        break;
    case "payPeriodEnd":

        let periodEndStartGap = new Date(end);
        periodEndStartGap.setDate(periodEndStartGap.getDate())

        // let periodEndDateHiredGap = new Date(end);
        // periodEndDateHiredGap.setDate(periodEndDateHiredGap.getDate() - 1);

        let periodEndpayDate = new Date(end);
        periodEndpayDate.setDate(periodEndpayDate.getDate() + 1);

        $w('#payPeriodStart').maxDate = periodEndStartGap;
        $w('#payDate').minDate = periodEndpayDate;
        // $w('#dateHired').maxDate = periodEndDateHiredGap;
        break;
    case "dateHired":

        let dateHiredGap = new Date(dateHired);
        dateHiredGap.setDate(dateHiredGap.getDate());
        $w('#payPeriodStart').minDate = dateHiredGap;
        $w('#payDate').minDate = dateHiredGap;
        $w('#payPeriodEnd').minDate = dateHiredGap;
        break;
    default:
        break;
    }
}
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////// 
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

function enableCheckbox(e) {
    let { checked } = e.target;

    if (checked) {
        let startDate;
        let maxDate;
        const periodEnd = $w('#payPeriodEnd').value;
        if (periodEnd) {
            startDate = new Date(periodEnd.getFullYear(), 0, 1);
            maxDate = new Date(periodEnd);
            maxDate.setDate(maxDate.getDate());
        } else {
            maxDate = new Date(new Date().getFullYear(), 12, 0);
            startDate = new Date(new Date().getFullYear(), 0, 1);
        }

        $w('#dateHired').enable();
        $w('#dateHired').required = true;
        $w('#dateHired').minDate = startDate;
        $w('#dateHired').maxDate = maxDate;
    } else {
        $w('#dateHired').value = null;
        $w('#dateHired').disable();
        $w('#dateHiredTitle').hide();
        $w('#dateHired').required = false;
        $w('#payPeriodStart').minDate = null;
        $w('#PdateHired').text = '';
        $w('#payDate').minDate = null;
        $w('#payPeriodEnd').minDate = null;
        // calculateNumberOfMonths();
    }
}

/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
//////////////////////calculate pay stub section///////////////////// 
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
function calculateCurrentEarnings() {
    let formatcurrentEarnings;
    if ($w('#payFrequency').value === "") {
        return

    }
    currentYear = new Date($w('#payPeriodEnd').value).getFullYear();

    let payFreqToJson = $w('#payFrequency').value;
    payFrequncey = getPayFrequncey($w('#payFrequency').value, currentYear);

    jsonPaystub.payFrequency = payFreqToJson.toString();

    if ($w('#salaryType').value === "Hourly") {
        hourly = parseFloat($w('#hourlyRate').value);
        hoursWorked = parseFloat($w('#hoursWorked').value);
        currentEarnings = hourly * hoursWorked;
    } else {
        annualSalary = parseFloat($w('#annualSalary').value);
        currentEarnings = annualSalary / payFrequncey;
        console.log("current", currentEarnings, "payFrequncey", payFrequncey);
    }
    let curEr = currentEarnings.toFixed(2)

    formatcurrentEarnings = new Intl.NumberFormat().format(Number(curEr));
    console.log("formatcurrentEarnings", formatcurrentEarnings);
    if (currentEarnings > 0) {
        if (!isMobile()) {
            $w('#PcurrentEarnings').text = formatcurrentEarnings;
            $w('#PcurrentEarnings').show();
        }

        jsonPaystub.currentEarnings = formatcurrentEarnings;

        if ($w('#payFrequency').value === "") {
            return
        }

        calculateYdtGross()
        calculateNetpay()
        calculateYdtDeduction();
    }
}

// function calculateNumberOfMonths() {
//     if ($w('#dateHired').value !== null) {
//         if ($w('#payPeriodEnd').value !== null) {
//             monthsFromDayOne = dateRange($w('#dateHired').value, $w('#payPeriodEnd').value)

//         }
//     } else {
//         // console.log("date hired is null");
//         let year = $w('#payPeriodEnd').value;
//         // console.log("year:", year);
//         if (year) {
//             let date = new Date("1/1/" + year.getFullYear());
//             monthsFromDayOne = dateRange(date, $w('#payPeriodEnd').value)

//         }

//     }
//     // console.log("months from day one", monthsFromDayOne);
//     calculateYdtGross()
//     calculateNetpay()
//     calculateYdtDeduction();
// }

function calculateYdtGross() {
    let formatYtd;
    if ($w('#payPeriodEnd').value && $w('#payFrequency').value) {
        let payFreq = $w('#payFrequency').value;
        let ytd = (ytdUtil(payFreq))
        ydtGross = currentEarnings * ytd
        let yG = ydtGross.toFixed(2)
        // ydtGross = ydtGross.toFixed(2);
        formatYtd = new Intl.NumberFormat().format(Number(yG));
        console.log("formatYtd", formatYtd);
        // console.log("ytd gross:", formatYtd);
        if (!isMobile()) {
            $w('#pYdtGross').text = formatYtd.toString();
            $w('#pYdtGross').show();
        }

        jsonPaystub.ydtGross = formatYtd.toString();
        calculateYdtIncome()
    }

}

function calculateYdtDeduction() {
    let formatYtdDeduction;
    if ($w('#payDate').value && $w('#payFrequency').value) {
        let payFreq = $w('#payFrequency').value;
        let ytd = (ytdUtil(payFreq))
        // console.log("deductions", currentDeductionsSum);
        ydtDeduction = currentDeductionsSum * ytd;
        let yD = ydtDeduction.toFixed(2);
        console.log("yD", yD);

        formatYtdDeduction = new Intl.NumberFormat().format(Number(yD));
        if (!isMobile()) {
            $w('#pYdtDeduction').text = formatYtdDeduction.toString();
            $w('#pYdtDeduction').show();
        }

        calculateYdtIncome()
        calculateNetpay()
        jsonPaystub.ydtDeductions = formatYtdDeduction.toString();
    }

}

function calculateYdtIncome() {
    let formatYtdNetpay;
    ydtIncome = ydtGross - ydtDeduction;
    let yI = ydtIncome.toFixed(2);
    console.log("yI", yI);
    formatYtdNetpay = new Intl.NumberFormat().format(Number(yI));
    if (!isMobile()) {
        $w('#pYdtNetPay').text = formatYtdNetpay.toString();
        $w('#pYdtNetPay').show();
    }

    jsonPaystub.ydtNetPay = formatYtdNetpay.toString();

}

function calculateNetpay() {
    let formatNetpay;
    if (currentEarnings > 0) {

        netPay = (currentEarnings - currentDeductionsSum) + currentAdditionsSum;
        let nP = netPay.toFixed(2);
        console.log("np", nP);
        formatNetpay = new Intl.NumberFormat().format(Number(nP));
        if (!isMobile()) {
            $w('#pNetPay').text = formatNetpay.toString();
            $w('#pNetPay').show();
        }

        jsonPaystub.netPay = formatNetpay.toString();
    } else {
        return
    }

}
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////// 
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

function checkProperties() {
    // let { id: buttoname } = e.target;

    const isAdditionsValid = checkRepeaterValidtion("additions");
    const isDeductionValid = checkRepeaterValidtion("deductions");
    const isSpecialChar = checkValidationForSpecialChars();
    const isValid = checkValidation();
    // console.log("isAdditionsValid:", isAdditionsValid, "isDeductionValid:", isDeductionValid, "isSpecialChar:", isSpecialChar, "isValid:", isValid);
    if (isValid && isAdditionsValid && isDeductionValid && isSpecialChar) {
        console.log("all fields are filed with data making a requset...");
        return true;
    }
    return false;

}

export async function downloadPdfFromServer() {
    const isValid = checkProperties();

    if (isValid) {
        // console.log("downloading.......")
        $w('#image50').show();
        console.log(jsonPaystub);
        let res = await downloadPDF(jsonPaystub);
        $w('#image50').hide();
        openLightbox('LB3 - Download');
        $w('#html1').postMessage(res);
    }

}

export async function emailPdfFromServer() {
    const isValid = checkProperties();

    if (isValid) {
        //  console.log("sending email....");
        openLightbox('LB1- Send_flow1', {
            data: jsonPaystub,
        });
    }

}

function showValidation(elementToBlur) {
    const element = getElement(elementToBlur);
    element.updateValidityIndication();
}

function checkValidation() {

    return inputFields.reduce((accumulator, field) => {
        // Check if previous value is already set to false, skip checking
        if (!accumulator) {
            return false;
        }

        // Check values
        const element = getElement(field.name);
        // console.log("element.name", field.name);
        // console.log("element.valid", element.valid);
        // console.log("element.required", element.required);
        if (element.required && !element.valid) {

            element.scrollTo();
            showValidation(field.name);

            return false;
        } else {
            console.log("filed is ready !!", element.id);
        }

        return accumulator;
    }, true);

}

function checkValidationForSpecialChars() {

    const re = /[`~&<>;/[\]|{}=`]/;

    for (let field of inputFields) {
        const element = getElement(field);
        const value = element.value;
        const test = re.test(value); // if value has a special characters the validation should not pass
        if (test === true) {
            return false
        }
    }

    return true;
}

// function setValidationForEmail() {
//     const fileds = inputFields.filter(filed => filed.name === "employeeEmail" || filed.name === "businessEmail");
//     let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     for (let field of fileds) {
//         const element = getElement(field.name);

//         element.onCustomValidation((value, reject) => {
//             const test = re.test(value);
//             if (test === false) {
//                 reject("input cant contains special char ");
//             }
//         });

//     }
// }

function checkRepeaterValidtion(repeater) {
    let isValid = true
    const re = /[`~&<>;/[\]|{}=`]/;
    $w(`#${repeater}`).forEachItem(($item, itemData, index) => {
        let typeValue = $item(`#${repeater}Type`).value;
        let amountValue = $item(`#${repeater}Amount`).value;

        let typeTest = re.test(typeValue);
        let amountTest = re.test(amountValue);

        if (typeTest === true) {
            $item(`#${repeater}Type`).scrollTo();
            $item(`#${repeater}Type`).updateValidityIndication();
            isValid = false;

        }

        if (amountTest === true) {
            $item(`#${repeater}Amount`).scrollTo();
            $item(`#${repeater}Amount`).updateValidityIndication();

            isValid = false;

        }
    })

    return isValid;
}

export function linkedinSocial_click(event) {
    $w('#positionSocialLink').postMessage(`https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.wix.com/tools/pay-stub-generator&title=Wix%20Paystub%20Generator&summary=I%20just%20made%20an%20payslip%20for%20my%20clients%20with%20Wix%20Paystub%20Generator.%20Check%20out%20this%20professional%20business%20tool%20and%20create%20your%20own%20payslip%20today!%20&source=`);
}

export function facebookSocial_click(event) {
    $w('#positionSocialLink').postMessage(`https://www.facebook.com/sharer/sharer.php?u=https%3A//www.wix.com/tools/pay-stub-generator`);
}

export function twitterSocial_click(event) {
    $w('#positionSocialLink').postMessage(`https://twitter.com/intent/tweet?text=I%20just%20made%20an%20payStub%20for%20my%20cemployee%20with%20Wix%20Paystub%20Generator.%20Check%20out%20this%20professional%20business%20tool%20and%20create%20your%20own%20paystub%20today!%20https%3A//www.wix.com/tools/pay-stub-generator`);
}

export function ytdUtil(payFreq) {
    let ytdGross;

    let amount = getDaysAmount(payFreq);
    let dateDaily = $w('#payPeriodEnd').value;
    let dateDaily1;

    if ($w('#wasHiredThisYear').checked) {
        dateDaily1 = $w('#dateHired').value;
    } else {
        let yearDaily = new Date().getFullYear();
        dateDaily1 = new Date('1/1/' + yearDaily);
    }

    let days = days_between(dateDaily, dateDaily1);
    // console.log("amount:", amount, "days worked:", days);
    ytdGross = (days / amount);
    ytdGross = Math.floor(ytdGross);
    // console.log("mutli amount:", ytdGross);
    return ytdGross;
}

function weeks_between(date1, date2) {
    // The number of milliseconds in one week
    var ONE_WEEK = 1000 * 60 * 60 * 24 * 7;
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();
    // Calculate the difference in milliseconds
    var difference_ms = Math.abs(date1_ms - date2_ms);
    // Convert back to weeks and return hole weeks
    let res = Math.floor(difference_ms / ONE_WEEK);
    console.log("weeks worked:", res);
    return res;
}

function days_between(date1, date2) {
    // The number of milliseconds in one days
    var day = 1000 * 3600 * 24;
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();
    // Calculate the difference in milliseconds
    var difference_ms = Math.abs(date1_ms - date2_ms);
    // Convert back to days and return hole days
    let res = Math.floor(difference_ms / day) + 1;

    console.log("days worked:", res);
    return res;
}